import {ExclamationCircleOutlined} from '@ant-design/icons';
import {message, Modal} from 'antd';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useMutation, useQueryClient} from 'react-query';

import useAlerts from '@/hooks/useAlerts';

export function showConfirm(t, description, onOk, title) {
  Modal.confirm({
    title: t(title || 'deleteConfirmation'),
    icon: <ExclamationCircleOutlined/>,
    content: description,
    onOk
  });
}

export const useCrud = (service, keyList, keyOne, skipNotify) => {
  const {t} = useTranslation('common');
  const queryClient = useQueryClient();

  const {putErrorCode} = useAlerts();

  const {mutateAsync: create, isLoading: isCreating, isSuccess: isCreatingSuccess} = useMutation(service?.save, {
    onSuccess: () => {
      queryClient.invalidateQueries(keyList);
      if (!skipNotify)
        message.success(t('createSuccess'));
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });

  const {
    mutateAsync: update,
    isLoading: isUpdating,
    isSuccess: isUpdatingSuccess,
    reset: updatingReset
  } = useMutation(service?.update, {
    onSuccess: ({data}) => {
      if (!skipNotify)
        message.success(t('updateSuccess'));
      queryClient.invalidateQueries(keyList);
      queryClient.invalidateQueries(keyOne);
      queryClient.invalidateQueries(data?._id);
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });

  const {mutateAsync: remove, isLoading: isRemoving} = useMutation(service?.delete, {
    onSuccess: () => {
      if (!skipNotify)
        message.success(t('deleteSuccess'));
      queryClient.invalidateQueries(keyList);
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });

  return {
    create,
    isCreating,
    update,
    isUpdating,
    remove,
    isRemoving,
    isSuccess: isCreatingSuccess || isUpdatingSuccess,
    isLoading: isCreating || isUpdating || isRemoving,
    //update
    updatingReset,
  };
};

export default useCrud;
